import React, { createContext, useState, useContext, useEffect } from "react";

// Import des fichiers de traduction
import en from "../locale/en.json";
import de from "../locale/de.json";
import fr from "../locale/fr.json";
import es from "../locale/es.json";
import it from "../locale/it.json";
import nl from "../locale/nl.json";
import pl from "../locale/pl.json";
import ro from "../locale/ro.json";
import pt from "../locale/pt.json";
import cs from "../locale/cs.json";


const translations = { en, fr, es, de, it, nl, pl, ro, pt, cs };

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  // Fonction utilitaire pour récupérer la langue navigateur
  const getBrowserLang = () => {
    const lang = navigator.language || navigator.userLanguage;
    return lang.split("-")[0];
  };

  // Au démarrage : priorité à localStorage, puis navigateur, puis défaut "fr"
  const getInitialLang = () => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang && translations[savedLang]) return savedLang;

    const browserLang = getBrowserLang();
    if (translations[browserLang]) return browserLang;

    return "en"; // langue par défaut si tout le reste échoue
  };

  const [lang, setLang] = useState(getInitialLang());
  const [dictionary, setDictionary] = useState(translations[lang]);

  // Mise à jour du dictionnaire à chaque changement de langue
  useEffect(() => {
    setDictionary(translations[lang]);
    localStorage.setItem("lang", lang); // mémoriser la langue choisie
  }, [lang]);

  // Fonction de traduction
  const t = (key) => dictionary[key] || key;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
